import { PickupOrder, PickupOrderStatus } from '@/api/pickup-orders/types/PickupOrder'
import { PkgShippingMethod, PkgStatus, UserPkg } from '@/api/user-package/types/UserPkg'

export const getPkgStatus = (pkg: UserPkg) => {
  if (pkg.isShipped) return 'נשלחה'
  if (pkg.status === PkgStatus.NeedId) return 'נדרש זיהוי'
  if (pkg.isPaid && !pkg.isShipped) return 'ממתין למשלוח'
  if (pkg.isReturnRequestActive) {
    if (pkg.returnLabelFalse) return 'דרושה תווית החזרה'
    return 'ממתין להחזרה'
  }
  if (pkg.isPhotoRequestActive || pkg.isShrinkRequestActive || pkg.isUniteRequestActive) return 'בקשה ממתינה לביצוע'
  return 'מוכנה למשלוח'
}
export const getPickupOrderStatus = (order: PickupOrder) => {
  if (!order.barcodeImg) return 'מחכה לברקוד'
  if (order.status === PickupOrderStatus.Picked) return 'נאספה מפריימרק'
  if (order.status === PickupOrderStatus.Pending) return 'לקראת איסוף מהסניף'
  if (order.status === PickupOrderStatus.FalseBarcode) return 'ברקוד שגוי'
  if (order.status === PickupOrderStatus.Cancelled) return 'בוטל'
  return null
}
export const getPkgStatusTooltip = (pkg: UserPkg) => {
  if (pkg.status === PkgStatus.NeedId) return 'החבילה נדרשת זיהוי'
  if (pkg.isReturnRequestActive) return 'לביטול הבקשה אנא פה לשירות הלקוחות'
  if (pkg.isPhotoRequestActive || pkg.isShrinkRequestActive || pkg.isUniteRequestActive) return 'לא ניתן לשלח את החבילה כשיש בקשה בטיפול'
  return null
}
export const isPkgUniteable = (pkg: UserPkg) => {
  return (
    !pkg.isPaid &&
    !pkg.isShipped &&
    !pkg.isReturnRequestActive &&
    !pkg.isShrinkRequestActive &&
    !pkg.isPhotoRequestActive &&
    !pkg.isUniteRequestActive
  )
}
export const getIsSplitPkg = (pkgs: UserPkg[], pkg: UserPkg) => {
  return pkgs.some(p => !p.isShipped && p.id !== pkg.id && p.fromTrackingNumber === pkg.fromTrackingNumber)
}
export const shippingMethodToLabel = {
  [PkgShippingMethod.DoorToDoor]: 'משלוח עד הבית',
  [PkgShippingMethod.PickUpPoint]: 'איסוף עצמי מנקודת חלוקה',
  [PkgShippingMethod.Test]: 'משלוח בדיקה',
}
